import styled from 'styled-components';
import {FormControl} from "@mui/material";
import {tokens} from "../../../theme";

export const SelectWithFallbackPanelWrapper = styled.div`
    width: fit-content;
    padding: 8px 12px;
`;

export const SelectWithFallbackGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
`;

export const StyledFormControlLabel = styled.label`
    font-size: ${tokens.fontSize.xs};
    font-weight: ${tokens.fontWeight.medium};
    color: ${({theme}) => theme.palette.text.secondary};
    text-transform: uppercase;
    letter-spacing: 0.6px;
    margin-bottom: 4px;
`;


export const StyledFormControl = styled(FormControl)`
    && {
        width: fit-content;
        min-width: 240px;

        .MuiOutlinedInput-root {
            border-radius: ${tokens.radius.md};
            background: ${({theme}) => theme.palette.background.paper};
            font-size: ${tokens.fontSize.sm};
            color: ${({theme}) => theme.palette.text.primary};
            min-height: 48px;
            
            fieldset {
                border-color: ${({theme}) => theme.palette.divider};
            }

            &:hover fieldset {
                border-color: ${({theme}) => theme.palette.dividers.strong};
            }

            &.Mui-focused fieldset {
                border-color: ${({theme}) => theme.palette.text.primary};
                border-width: 1px;
            }
        }

        .MuiSelect-select {
            padding: 8px 12px;
            padding-right: 36px !important;
            text-transform: none;
        }
        
        svg {
            color: ${({theme}) => theme.palette.text.primary};
        }
    }
`;